var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-data-table", {
    staticClass: "elevation-1 bordered renters-list-table",
    attrs: {
      headers: _vm.headers,
      items: _vm.reservees,
      "hide-default-footer": true,
      "items-per-page": 100,
      "sort-by": "calories"
    },
    scopedSlots: _vm._u([
      {
        key: "top",
        fn: function() {
          return [
            _c(
              "v-toolbar",
              { staticClass: "grey lighten-4 p-2", attrs: { flat: "" } },
              [
                _c("v-toolbar-title", [
                  _c("h4", { staticClass: "m-0" }, [_vm._v(_vm._s(_vm.title))])
                ]),
                _vm._v(" "),
                _c("v-spacer"),
                _vm._v(" "),
                _c(
                  "v-dialog",
                  {
                    attrs: { "max-width": "500px" },
                    model: {
                      value: _vm.dialogDelete,
                      callback: function($$v) {
                        _vm.dialogDelete = $$v
                      },
                      expression: "dialogDelete"
                    }
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c("v-card-title", { staticClass: "text-h5" }, [
                          _vm._v("Are you sure you want to delete this item?")
                        ]),
                        _vm._v(" "),
                        _c(
                          "v-card-actions",
                          [
                            _c("v-spacer"),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "blue darken-1", text: "" },
                                on: { click: _vm.closeDelete }
                              },
                              [_vm._v("Cancel")]
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { color: "blue darken-1", text: "" },
                                on: { click: _vm.deleteItemConfirm }
                              },
                              [_vm._v("OK")]
                            ),
                            _vm._v(" "),
                            _c("v-spacer")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "item.index",
        fn: function(ref) {
          var item = ref.item
          return [
            item._id
              ? [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.indexOfItem(item)) +
                      "\n        "
                  )
                ]
              : _vm._e()
          ]
        }
      },
      {
        key: "item.renter",
        fn: function(ref) {
          var item = ref.item
          return [
            item._id
              ? _c(
                  "div",
                  { staticClass: "d-flex flex-column" },
                  [
                    item.full_name
                      ? [
                          _c("div", [
                            _c("span", [
                              _c("strong", [_vm._v(_vm._s(item.full_name))]),
                              _vm._v(
                                ", " +
                                  _vm._s(item.gender) +
                                  ", " +
                                  _vm._s(_vm.ageFromBday(item.dob)) +
                                  " y.o. "
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("div", [
                            _c("span", [
                              _vm._v(_vm._s(_vm.formatDate(item.dob)))
                            ])
                          ])
                        ]
                      : [
                          _c("span", { staticClass: "text-warning" }, [
                            _vm._v("Not set")
                          ])
                        ]
                  ],
                  2
                )
              : _vm._e()
          ]
        }
      },
      {
        key: "item.parameters",
        fn: function(ref) {
          var item = ref.item
          return [
            item._id
              ? _c("div", { staticClass: "d-flex flex-column" }, [
                  _c("div", [
                    _c("strong", [_vm._v("Height:")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.heightCm(item.height)))])
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm.is_international_canadian
                        ? [
                            _c(
                              "strong",
                              [
                                _vm._v("Weight "),
                                _vm.weight_unit_is_kg ||
                                _vm.$store.state.model.reservation
                                  .is_international_customer
                                  ? [_vm._v("Kg's")]
                                  : _vm._e(),
                                _vm.weight_unit_is_kg == 0 &&
                                !_vm.$store.state.model.reservation
                                  .is_international_customer
                                  ? [_vm._v("Lbs")]
                                  : _vm._e(),
                                _vm._v(":")
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.weight))])
                          ]
                        : [
                            _c(
                              "strong",
                              [
                                _vm._v("Weigh "),
                                _vm.weight_with_kg ||
                                _vm.$store.state.model.reservation
                                  .is_international_customer
                                  ? [_vm._v("Kg's")]
                                  : _vm._e(),
                                _vm._v(":")
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("span", [_vm._v(_vm._s(item.weight))])
                          ]
                    ],
                    2
                  ),
                  _vm._v(" "),
                  _c("div", [
                    _c("strong", [_vm._v("Shoe size:")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.shoeSize(item.shoe_size)))])
                  ])
                ])
              : _vm._e()
          ]
        }
      },
      {
        key: "item.skier_type",
        fn: function(ref) {
          var item = ref.item
          return [
            item._id && item.skier_type
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-center align-items-center h-100 w-100"
                  },
                  [
                    _c("span", [
                      _vm._v(_vm._s(_vm.skierTypeById(item.skier_type).title))
                    ])
                  ]
                )
              : _vm._e()
          ]
        }
      },
      {
        key: "item.package_id",
        fn: function(ref) {
          var item = ref.item
          return [
            item._id && item.package_id
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex flex-column justify-content-center align-items-center h-100 w-100"
                  },
                  [
                    _c("span", [_vm._v(_vm._s(_vm.packageText(item)))]),
                    _vm._v(" "),
                    item.addons && item.addons.length
                      ? [
                          _c(
                            "v-tooltip",
                            {
                              attrs: { bottom: "" },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function(ref) {
                                      var on = ref.on
                                      var attrs = ref.attrs
                                      return [
                                        _c(
                                          "span",
                                          _vm._g(
                                            _vm._b(
                                              {
                                                staticClass: "text-light-blue"
                                              },
                                              "span",
                                              attrs,
                                              false
                                            ),
                                            on
                                          ),
                                          [
                                            _vm._v(
                                              "\n                            + " +
                                                _vm._s(item.addons.length) +
                                                " addons\n                        "
                                            )
                                          ]
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            },
                            [
                              _vm._v(" "),
                              _c("span", [_vm._v(_vm._s(_vm.addonsText(item)))])
                            ]
                          )
                        ]
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]
        }
      },
      {
        key: "item.actions",
        fn: function(ref) {
          var item = ref.item
          return [
            item._id
              ? _c(
                  "div",
                  {
                    staticClass:
                      "d-flex justify-content-center align-items-center  h-100 w-100"
                  },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-2",
                        attrs: { color: "accent" },
                        on: {
                          click: function($event) {
                            return _vm.editItem(item)
                          }
                        }
                      },
                      [_vm._v("\n                mdi-pencil\n            ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "v-icon",
                      {
                        attrs: { color: "error" },
                        on: {
                          click: function($event) {
                            return _vm.deleteItem(item)
                          }
                        }
                      },
                      [_vm._v("\n                mdi-delete\n            ")]
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        }
      },
      {
        key: "header.skier_type",
        fn: function() {
          return [
            _c("span", [_vm._v("Skier Type")]),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: { icon: "" },
                on: {
                  click: function($event) {
                    return _vm.ui__openModalByName({
                      name: "dialog_skier_types"
                    })
                  }
                }
              },
              [_c("v-icon", [_vm._v("mdi-information-outline")])],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "header.package_id",
        fn: function() {
          return [
            _c("span", [_vm._v("Package")]),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: { icon: "" },
                on: {
                  click: function($event) {
                    return _vm.ui__openModalByName({
                      name: "dialog_rental_rates"
                    })
                  }
                }
              },
              [_c("v-icon", [_vm._v("mdi-information-outline")])],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }